import { ChainId } from '@nevellusdex/core-sdk'
import { GRAPH_HOST } from 'app/services/graph/constants'
import { getTokenSubset } from 'app/services/graph/fetchers/exchange'
import {
  enceladusPairAddressesQuery,
  enceladusPoolHistoriesQuery,
  enceladusPoolsQuery,
  enceladusNvlsPerBlockQuery,
  enceladusTotalAllocPointQuery,
  enceladusV2PairAddressesQuery,
  enceladusV2PoolsQuery,
  dioneNativeRewarderPoolsQuery,
  dionePairAddressesQuery,
  dionePoolsQuery,
  dionePoolsQueryV2,
  dionePoolsWithUserQuery,
  dionePoolsWithUserQueryV2,
  poolsQuery,
  poolsV2Query,
} from 'app/services/graph/queries'
import { request } from 'graphql-request'

export const DIONE = {
  [ChainId.MATIC]: 'notUse',
  [ChainId.MATIC_TESTNET]: 'dione-mumbai',
}

// @ts-ignore TYPE NEEDS FIXING
export const dione = async (query, chainId = ChainId.ETHEREUM, variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[chainId]}/subgraphs/name/${DIONE[chainId]}`, query, variables)

export const ENCELADUS_V2 = {
  [ChainId.ETHEREUM]: 'fernandocfjr/enceladusv2',
  [ChainId.GÖRLI]: 'fernandocfjr/enceladusv2-goerli'
}

// @ts-ignore TYPE NEEDS FIXING
export const enceladusV2 = async (query, chainId = ChainId.GÖRLI, variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[chainId]}/subgraphs/name/${ENCELADUS_V2[chainId]}`, query, variables)

export const ENCELADUS = {
  [ChainId.ETHEREUM]: 'fernandocfjr/enceladus',
  [ChainId.GÖRLI]: 'fernandocfjr/enceladus-goerli'
}

// @ts-ignore TYPE NEEDS FIXING
export const enceladus = async (query, chainId = ChainId.GÖRLI, variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[chainId]}/subgraphs/name/${ENCELADUS[chainId]}`, query, variables)

export const getEnceladusTotalAllocPoint = async () => {
  const {
    enceladus: { totalAllocPoint },
  } = await enceladus(enceladusTotalAllocPointQuery)
  return totalAllocPoint
}

export const getEnceladusNvlsPerBlock = async () => {
  const {
    enceladus: { nvlsPerBlock },
  } = await enceladus(enceladusNvlsPerBlockQuery)
  return nvlsPerBlock / 1e18
}

export const getEnceladusFarms = async (variables = undefined) => {
  const { pools } = await enceladus(poolsQuery, undefined, variables)
  return pools
}

export const getEnceladusPairAddreses = async () => {
  const { pools } = await enceladus(enceladusPairAddressesQuery)
  // @ts-ignore
  return pools?.map((pool) => pool.pair)
}

export const getEnceladusV2Farms = async (variables = undefined) => {
  const { pools } = await enceladus(poolsV2Query, undefined, variables)

  const tokens = await getTokenSubset(ChainId.GÖRLI, {
    // @ts-ignore TYPE NEEDS FIXING
    tokenAddresses: Array.from(pools.map((pool) => pool.rewarder.rewardToken)),
  })

  // @ts-ignore TYPE NEEDS FIXING
  return pools.map((pool) => ({
    ...pool,
    rewardToken: {
      // @ts-ignore TYPE NEEDS FIXING
      ...tokens.find((token) => token.id === pool.rewarder.rewardToken),
    },
  }))
}

export const getEnceladusV2PairAddreses = async () => {
  const { pools } = await enceladusV2(enceladusV2PairAddressesQuery)
  // @ts-ignore
  return pools?.map((pool) => pool.pair)
}

export const getDioneFarms = async (chainId = ChainId.ETHEREUM, variables = undefined) => {
  const v2Query = chainId && [ChainId.MATIC, ChainId.MATIC_TESTNET].includes(chainId)

  if (v2Query) {
    const { pools } = await dione(dionePoolsQueryV2, chainId, variables)
    const tokens = await getTokenSubset(chainId, {
      // @ts-ignore TYPE NEEDS FIXING
      tokenAddresses: Array.from(pools.map((pool) => pool.rewarder.rewardToken)),
    })

    const nativePools =
      chainId === ChainId.XDAI ? await dione(dioneNativeRewarderPoolsQuery, chainId, variables) : undefined

    // @ts-ignore TYPE NEEDS FIXING
    return pools.map((pool) => ({
      ...pool,
      rewardToken: {
        // @ts-ignore TYPE NEEDS FIXING
        ...tokens.find((token) => token.id === pool.rewarder.rewardToken),
      },
      rewarder: {
        ...pool.rewarder,
        native: {
          ...(nativePools
            ? // @ts-ignore TYPE NEEDS FIXING
              nativePools.nativeRewarderPools.find((nativePool) => nativePool.id === pool.id)
            : undefined),
        },
      },
    }))
  } else {
    const { pools } = await dione(dionePoolsQuery, chainId, variables)
    return pools
  }
}

export const getDionePairAddreses = async (chainId = ChainId.ETHEREUM) => {
  console.debug('getDionePairAddreses')
  const { pools } = await dione(dionePairAddressesQuery, chainId)
  // @ts-ignore
  return pools?.map((pool) => pool.pair)
}

export const getEnceladusPools = async (chainId = ChainId.GÖRLI, variables: any) => {
  const { pools } = await enceladus(enceladusPoolsQuery, chainId, variables)
  return pools
}

export const getEnceladusV2Pools = async (chainId = ChainId.GÖRLI, variables: any) => {
  const { pools } = await enceladusV2(enceladusV2PoolsQuery, chainId, variables)
  const tokens = await getTokenSubset(ChainId.GÖRLI, {
    // @ts-ignore TYPE NEEDS FIXING
    tokenAddresses: Array.from(pools.map((pool) => pool.rewarder.rewardToken)),
  })

  // @ts-ignore TYPE NEEDS FIXING
  return pools.map((pool) => ({
    ...pool,
    rewardToken: {
      // @ts-ignore TYPE NEEDS FIXING
      ...tokens.find((token) => token.id === pool.rewarder.rewardToken),
    },
  }))
}

export const getDioneFarmsWithUser = async (chainId = ChainId.ETHEREUM, variables = undefined) => {
  const v2Query = chainId && [ChainId.MATIC, ChainId.MATIC_TESTNET, ChainId.XDAI].includes(chainId)

  if (v2Query) {
    const { pools } = await dione(dionePoolsWithUserQueryV2, chainId, variables)
    const tokens = await getTokenSubset(chainId, {
      // @ts-ignore TYPE NEEDS FIXING
      tokenAddresses: Array.from(pools.map((pool) => pool.rewarder.rewardToken)),
    })

    // @ts-ignore TYPE NEEDS FIXING
    return pools.map((pool) => ({
      ...pool,
      rewardToken: {
        // @ts-ignore TYPE NEEDS FIXING
        ...tokens.find((token) => token.id === pool.rewarder.rewardToken),
      },
    }))
  } else {
    const { pools } = await dione(dionePoolsWithUserQuery, chainId, variables)
    return pools
  }
}

export const getEnceladusPoolHistories = async (chainId = ChainId.GÖRLI, variables: any) => {
  const { poolHistories } = await enceladus(enceladusPoolHistoriesQuery, chainId, variables)
  return poolHistories
}
